import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { KeyHandlerDirective } from '../../../directives/key-handler.directive';

@Component({
    selector: 'lex-ok-cancel-dialog',
    templateUrl: './ok-cancel-dialog.component.html',
    styleUrls: ['./ok-cancel-dialog.component.scss'],
    standalone: false
})
export class OkCancelDialogComponent extends KeyHandlerDirective {

	public title = 'Confirm';
	public message = 'Are you sure?';
	public hideCancel = false;
	public showAcknowledge = false;
	public acknowledged = false;

	constructor(private dialogRef: MatDialogRef<OkCancelDialogComponent>, @Inject(MAT_DIALOG_DATA) data) {
		super();
		if (data) {
			if (data.title) this.title = data.title;
			if (data.message) this.message = data.message;
			if (data.hideCancel) this.hideCancel = true;
			if (data.showAcknowledge) this.showAcknowledge = true;
		}
	}

	ok() {
		this.dialogRef.close(true);
	}

	cancel() {
		this.dialogRef.close(false);
	}
}
